// Smart Infovision — SEO URL helpers + keyword variants.
// Each city/state page can be reached via multiple keyword-rich URLs that all
// render the same content but with the matching keyword in H1, title, and meta.

// City keyword variants — each Route catches the same slug, the page reads
// the keyword from window.location.pathname to vary the on-page copy.
export const CITY_KEYWORDS = [
  { slug: "digital-board-in",       label: "Digital Board",          plural: "Digital Boards" },
  { slug: "smart-board-in",         label: "Smart Board",            plural: "Smart Boards" },
  { slug: "interactive-flat-panel-in", label: "Interactive Flat Panel", plural: "Interactive Flat Panels" },
  { slug: "interactive-panel-in",   label: "Interactive Panel",      plural: "Interactive Panels" },
  { slug: "smart-classroom-in",     label: "Smart Classroom",        plural: "Smart Classrooms" },
  { slug: "online-teaching-setup-in", label: "Online Teaching Setup", plural: "Online Teaching Setups" },
];

export const STATE_KEYWORDS = [
  { slug: "digital-board-dealer-in", label: "Digital Board Dealer", plural: "Digital Board Dealers" },
  { slug: "smart-board-dealer-in",   label: "Smart Board Dealer",   plural: "Smart Board Dealers" },
  { slug: "interactive-flat-panel-dealer-in", label: "Interactive Flat Panel Dealer", plural: "IFP Dealers" },
];

export const CITY_BASE = "/digital-board-in";
export const STATE_BASE = "/digital-board-dealer-in";

export const cityHref = (slug) => `${CITY_BASE}/${slug}`;
export const stateHref = (slug) => `${STATE_BASE}/${slug}`;

// Build a keyword-specific city URL — e.g. cityKeywordHref('smart-board-in', 'patna')
// → '/smart-board-in/patna'
export const cityKeywordHref = (kw, slug) => `/${kw}/${slug}`;

export const stripCityPrefix = (slug = "") => slug; // no longer needed — we use path-segment URLs
export const stripStatePrefix = (slug = "") => slug;

/**
 * Detect which keyword the current pathname uses. Returns the matching keyword
 * descriptor (label/plural/slug) or null. Used by CityDetail/StateDetail to
 * vary on-page copy so each URL variant has unique-ish content for SEO.
 */
export function detectCityKeyword(pathname = "") {
  for (const kw of CITY_KEYWORDS) {
    if (pathname.startsWith(`/${kw.slug}/`)) return kw;
  }
  return CITY_KEYWORDS[0];
}

export function detectStateKeyword(pathname = "") {
  for (const kw of STATE_KEYWORDS) {
    if (pathname.startsWith(`/${kw.slug}/`)) return kw;
  }
  return STATE_KEYWORDS[0];
}
